module.exports = require('./dist/Sticky');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-stickynode/index.js
 ** module id = 1298
 ** module chunks = 1
 **/